import React from 'react';

import { CloudInventory } from './index';

/** The new inventory page selected by inventory_v3_features. */
export const InventoryV3Page = () => <CloudInventory useInventoryV3 />;
